/* eslint-disable @typescript-eslint/no-explicit-any */

declare global {
    interface Window {
        grecaptcha: any;
    }
}

const grecaptcha = window.grecaptcha;

const fireCaptcha = () => {
    return new Promise((resolve) => {
        grecaptcha.ready(function () {
            grecaptcha
                .execute('6LdDp8gaAAAAAGwy86x68-rkIgkHVfLQcK1_Xy1x', {
                    action: 'otmena',
                })
                .then(function (token: string) {
                    resolve(token);
                });
        });
    });
};

const BASE_URL: string = '/app/ajax/out/';
// const BASE_URL: string = 'https://mc21.ru/app/ajax/out/tmp.php';

type Obj = Record<string, any>;

export const fetchPost = async (data: Obj, action?: string) => {
    const headers = new Headers();

    headers.append('Content-Type', 'application/json');

    const grecaptchaRes = await fireCaptcha();

    const resultData = { ...data, recaptcha: grecaptchaRes };

    const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(resultData),
    };

    const res = await fetch(
        `${BASE_URL}${action ? `?action=${action}` : ''}`,
        options,
    );

    if (!res.ok) throw new Error('Failed to fetch');

    return res.json();
};
